import React from 'react';
import PropTypes from 'prop-types';
import MethodSelect from '../MethodSelect';
import MadhabSelect from '../MadhabSelect';
import CitySelect from '../Home/CitySelect'
import UrlPrefix from '../utils/UrlPrefix';
import Clock from "../Home/Clock";

require('./style.css');

const TopPanel = ({ method, madhab, cityObj, nextPrayer, onMethodChange, onMadhabChange, onLocationChange }) => {
  return (
    <div className="top-panel" style={{ backgroundImage: `url(${UrlPrefix}/images/${nextPrayer.name}.webp)`}}>
    {/* <img className="top-panel-options" src={`${UrlPrefix}/images/bplogo.png`} alt="Theislah Logo" height="100" width="180"/> */}
    
      <h4>Prayer Times at {cityObj.city}, {cityObj.state}, India</h4>
      <button />
      <span>Select Your Location</span> 
      <CitySelect value={cityObj.id} onChange={onLocationChange} />
      <h4>{nextPrayer.curDate} </h4><Clock />
      <h2 className="text-capitalize">{nextPrayer.name}</h2>
      <h1>{nextPrayer.time}</h1>
      <div className="top-panel-options">
        
        <MethodSelect value={method} onChange={onMethodChange} />
        <MadhabSelect value={madhab} onChange={onMadhabChange} />
      </div>
    </div>
  );
};

TopPanel.propTypes = {
  method: PropTypes.string.isRequired,
  madhab: PropTypes.string.isRequired,
  onLocationChange: PropTypes.func,
  onMethodChange: PropTypes.func,
  nextPrayer: PropTypes.shape({
    name: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
  })
};

export default TopPanel;
